import DateSortIcon from './component'

export default DateSortIcon
